import React from 'react'
import './index.scss'
import SparkleWelcome from '../../../../assets/images/mascot_welcome_logo.webp'

const SparkleLogo = () => {
    return <img className = 'sparkle-logo' src={SparkleWelcome} />
}

export default SparkleLogo